export default __webpack_public_path__ + "static/media/image-home-xl-test.0ad887b4.png";